import { Link } from 'react-router-dom';

const LINK_GROUPS = [
  {
    title: '频道导航',
    links: [
      { label: '首页', to: '/' },
      { label: '电影', to: '/category/movie' },
      { label: '电视剧', to: '/category/tv' },
      { label: '综艺', to: '/category/variety' },
    ],
  },
  {
    title: '热门内容',
    links: [
      { label: '最新更新', to: '/' },
      { label: '热门推荐', to: '/' },
      { label: '搜索发现', to: '/search' },
      { label: '关于我们', to: '/about' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-primary-800 text-background-100">
      <div className="mx-auto w-full max-w-[1360px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-leaf-line text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">丝瓜视频</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-100">
              丝瓜视频是面向影视爱好者的内容聚合平台，聚合电影、电视剧与综艺节目信息，帮助用户快速浏览、筛选与了解最新的影视资源。
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-3 text-sm text-primary-100">
              <span className="inline-flex items-center gap-1"><i className="ri-mail-line" /> hello@siguavideo.com</span>
              <span className="inline-flex items-center gap-1"><i className="ri-customer-service-2-line" /> 400-800-2025</span>
            </div>
          </div>

          {LINK_GROUPS.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50">
                <Link to="/" className="hover:text-accent-300">{group.title}</Link>
              </h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-sm text-primary-100 transition-colors hover:text-accent-300">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-700 pt-6 text-xs text-primary-200 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 丝瓜视频 版权所有 · 本站内容均为虚拟示范数据，仅供演示使用</p>
          <p>免责声明：站内影视信息仅作聚合展示，不提供真实视频播放服务</p>
        </div>
      </div>
    </footer>
  );
}